import { z } from "zod";

import { AccountSchema, CandidateProfileSchema, UserSchema } from "../models/generated";
import { AccountType, AccountTypeSchema } from "./account/account";

export const ProfileDetailSchema = UserSchema.extend({
  account: AccountSchema
});
export type ProfileDetail = z.infer<typeof ProfileDetailSchema>;

// Create profile schema (without id, createdAt, updatedAt)
export const CreateUserProfileSchema = UserSchema.omit({
  id: true,
  username: true,
  rank: true,
  createdAt: true,
  updatedAt: true
}).extend({
  referrerCode: z.string().optional(),
  accountType: AccountTypeSchema.default(AccountType.CANDIDATE)
});
export type CreateUserProfile = z.infer<typeof CreateUserProfileSchema>;

// Update profile schema (partial, without id, userId, createdAt, updatedAt)
export const UpdateUserProfileSchema = CreateUserProfileSchema.partial();
export type UpdateUserProfile = z.infer<typeof UpdateUserProfileSchema>;

// Set avatar schema
export const SetAvatarSchema = z.object({
  avatar: z.string().url()
});
export type SetAvatar = z.infer<typeof SetAvatarSchema>;

// Update candidate profile schema
export const UpdateCandidateProfileSchema = CandidateProfileSchema.pick({
  address: true,
  educationLevel: true,
  userGroup: true,
  careerGoal: true
}).partial();
export type UpdateCandidateProfile = z.infer<typeof UpdateCandidateProfileSchema>;
